import React, { useEffect, useState } from 'react'

import uuid from 'uuid/v4'

const targetAttributeName = 'data-intransigent-blocker-target'

const findByAttr = (attr, mutations) => mutations.find(m => m.attributeName === attr)
const isBlockerTarget = mutation => 'intransigentBlockerTarget' in mutation.target.dataset

const IntransigentBlocker = ({ property, value, children }) => {
    const [id] = useState(uuid())

    useEffect(() => {
        const rootEl = document.getElementById(id)

        const target = document.querySelector(`[${targetAttributeName}]`)

        if (target) {
            target.style.setProperty(property, value, 'important')

            const observer = new MutationObserver(mutations => {
                const styleMutation = findByAttr('style', mutations)

                const targetMutation = findByAttr(targetAttributeName, mutations)

                if (styleMutation && isBlockerTarget(styleMutation)) {
                    styleMutation.target.style.setProperty(property, value, 'important')
                }

                if (targetMutation && !isBlockerTarget(targetMutation)) {
                    targetMutation.target.dataset.intransigentBlockerTarget = true
                }
            })

            observer.observe(rootEl, {
                attributes: true,
                childList: true,
                subtree: true,
            })
        } else {
            console.error('You need to add `{...INTRANSIGENT_BLOCKER_TARGET}` to the block that you want to observe')
        }
    })

    return <div id={id}>{children}</div>
}

export const INTRANSIGENT_BLOCKER_TARGET = {
    [targetAttributeName]: true,
}

export default IntransigentBlocker
